module.exports = __webpack_public_path__ + "static/img/xuachuan.86e308b2.png";